import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Upload, Image, Button, Switch, Flex } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const EditModal = ({
  isModalVisible,
  handleOk,
  handleCancel,
  loading,
  initialValues,
}) => {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [previewImage, setPreviewImage] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue({
        category_name: initialValues.category_name,
        use_custom_image: initialValues.use_custom_image,
        active: initialValues.active,
      });
      //   form.setFieldsValue({ image: fileList.length > 0 ? fileList[0] : null });

      if (initialValues.full_custom_image_url) {
        // Ensure you're using the correct image key
        setFileList([
          {
            uid: "-1",
            name: "image",
            status: "done",
            url: initialValues.full_custom_image_url, // Ensure this URL is correct
          },
        ]);
      } else {
        setFileList([]);
      }
    }
  }, [initialValues, form, isModalVisible]);

  const handleChange = ({ fileList }) => {
    setFileList(fileList.slice(-1));
    form.setFieldsValue({ image: fileList.length > 0 ? fileList[0] : null });
  };

  const handlePreview = async (file) => {
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Select</div>
    </div>
  );

  //   const onFinish = (values) => {
  //     handleOk({ ...values, image: fileList[0]?.originFileObj || initialValues.image || null });
  //     form.resetFields();
  //     setFileList([]);
  //     setPreviewImage("");
  //   };

  const onFinish = async (values) => {
    const updatedValues = {};

    // Check for changed fields
    Object.keys(values).forEach((key) => {
      if (values[key] !== initialValues[key] && key !== "image") {
        updatedValues[key] = values[key];
      }
    });

    // Handle image separately
    if (fileList.length > 0 && fileList[0]?.originFileObj) {
      updatedValues.image = fileList[0].originFileObj;
    }
    if (fileList.length === 0 && initialValues.full_custom_image_url) {
      updatedValues.is_delete_image = true;
    }

    // Only proceed if there's something to update
    // if (Object.keys(updatedValues).length > 0) {
    await handleOk(initialValues?.id, updatedValues);
    // } else {
    //   notification.error({
    //     message: "No changes detected",
    //     duration: 2,
    //   });
    // }
  };

  return (
    <Modal
      title="Edit Category"
      open={isModalVisible}
      footer={null}
      onCancel={() => {
        handleCancel();
        form.resetFields();
        setFileList([]);
        setPreviewImage("");
      }}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="category_name"
          label="Category Name"
          rules={[
            { required: true, message: "Please input the Category Name" },
          ]}
        >
          <Input placeholder="Enter Category Name" />
        </Form.Item>
        <Flex gap="100px">
          <Form.Item
            name="use_custom_image"
            label="Use Custom Image"
            valuePropName="checked"
          >
            <Switch checkedChildren="Custom" unCheckedChildren="Default" />
          </Form.Item>
          <Form.Item
            name="active"
            label="Active/In active"
            valuePropName="checked"
          >
            <Switch checkedChildren="Active" unCheckedChildren="In active" />
          </Form.Item>
        </Flex>

        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) =>
            prevValues.use_custom_image !== currentValues.use_custom_image
          }
        >
          {({ getFieldValue }) => (
            <Form.Item
              name="image"
              label="Select Custom Image"
              rules={[
                {
                  required: getFieldValue("use_custom_image"),
                  message: "Please upload a custom image",
                },
              ]}
            >
              <Upload
                listType="picture-card"
                fileList={fileList}
                onPreview={handlePreview}
                onChange={handleChange}
                beforeUpload={() => false}
                maxCount={1}
                accept=".jpg,.jpeg,.png,.svg"
              >
                {fileList.length >= 1 ? null : uploadButton}
              </Upload>

              <small>Recommended sizes: 50×50 px, 100×100 px</small>
              <br />
              <small>Aspect ratio: 1:1</small>
              <br />
              <small>File size: 20–100 KB</small>

              {previewImage && (
                <Image
                  wrapperStyle={{ display: "none" }}
                  preview={{
                    visible: previewOpen,
                    onVisibleChange: (visible) => setPreviewOpen(visible),
                    afterOpenChange: (visible) =>
                      !visible && setPreviewImage(""),
                    toolbarRender: () => null,
                  }}
                  src={previewImage}
                />
              )}
            </Form.Item>
          )}
        </Form.Item>

        <Form.Item>
          <div className="flex items-center justify-end gap-4">
            <Button onClick={handleCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              Save Changes
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditModal;
